import React from "react";
import { Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

class NetworkBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOnline: navigator.onLine,
    };
  }

  componentDidMount() {
    window.addEventListener("online", this.handleOnline);
    window.addEventListener("offline", this.handleOffline);
  }

  componentWillUnmount() {
    window.removeEventListener("online", this.handleOnline);
    window.removeEventListener("offline", this.handleOffline);
  }

  handleOnline = () => {
    this.setState({ isOnline: true });
  };

  handleOffline = () => {
    this.setState({ isOnline: false });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { isOnline } = this.state;
    const { children, fallback } = this.props;

    if (!isOnline) {
      // Custom fallback support
      if (fallback) {
        return typeof fallback === "function" ? fallback() : fallback;
      }

      // Default offline UI
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
          <div className="bg-white p-8 rounded shadow-md text-center max-w-md">
            <h1 className="text-2xl font-semibold mb-4">Network Error</h1>

            <p className="mb-6 text-gray-600">
              It looks like you're offline. Please check your internet connection and try again.
            </p>

            <Button type="primary" icon={<ReloadOutlined />} onClick={this.handleReload}>
              Retry
            </Button>
          </div>
        </div>
      );
    }

    return children;
  }
}

export default NetworkBoundary;
